import { render, staticRenderFns } from "./AddPenaltiesAndRewardsType.vue?vue&type=template&id=588f4daa"
import script from "./AddPenaltiesAndRewardsType.vue?vue&type=script&lang=js"
export * from "./AddPenaltiesAndRewardsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports